module.exports = __webpack_public_path__ + "entry-logged-out-0d45d450/salary-background-desktop-fb6bac36d867671784f75b6069f4678c.svg";